import {useIntl} from 'react-intl';

import {DownloadIcon} from '../../../icons/download';

import {FilePreviewAction} from './file-preview-action';

type Props = {
    downloadUrl: string;
    onDownload?: () => void;
};

export const FilePreviewActionDownload = ({downloadUrl, onDownload}: Props) => {
    const intl = useIntl();
    const tooltip = intl.formatMessage({
        id: 'single_image_view.download_tooltip',
        defaultMessage: 'Download',
    });

    return (
        <FilePreviewAction
            as='a'
            target='_blank'
            rel='noopener noreferrer'
            href={downloadUrl}
            download={true}
            onClick={onDownload}
            tooltip={tooltip}
            aria-label={tooltip}
        >
            <DownloadIcon width={20} height={20} />
        </FilePreviewAction>
    );
};
